/**
 * Splits a combined street address into separate lines for display
 * Takes an address string that might contain our standard "$$$$" separator
 * and breaks it into primary and secondary address lines.
 *
 * @param address - Full address string, possibly containing the "$$$$" separator
 * @returns An object with \{ line1, line2 \} as separate address components
 */
export const parseStreetAddress = (address?: string | null): { line1: string; line2: string } => {
  if (!address) {
    return { line1: '', line2: '' };
  }

  const [line1, line2 = ''] = address.split('$$$$');
  return { line1, line2 };
};
